module.exports = __webpack_public_path__ + "static/media/centerMatRed95.da1dd0b6.png";